import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const FAQS = [
    { q: "Мені потрібно щось знати про Google Ads?", a: "Нічого. Ви відповідаєте на питання про свій бізнес — ми беремо все інше на себе." },
    { q: "Ви можете самостійно змінювати щось у моїй рекламі?", a: "Зараз — ні. AutoAds тільки аналізує і готує рекомендації. Всі зміни вносите ви по нашій інструкції. Пізніше можна увімкнути автоматичну оптимізацію — але тільки за вашим дозволом." },
    { q: "Чи є гарантія результату?", a: "Ми не можемо гарантувати конкретні числа. Але ми гарантуємо інше: скасування в один клік без штрафів. Ніяких контрактів." },
    { q: "Чи можна спробувати безкоштовно?", a: "Ні, AutoAds — це платний сервіс з першого дня. Зате ви можете скасувати підписку в 1 клік у будь-який момент, а дані бізнесу та звітів зберігаються." },
    { q: "Що якщо у мене немає сайту?", a: "Допоможемо налаштувати Google Business Profile безкоштовно. Або порекомендуємо сайт від $35/міс." },
    { q: "Що буде з моїми даними якщо я піду?", a: "Все зберігається. Якщо повернетесь — не треба починати з нуля." },
    { q: "Коли побачу перших клієнтів?", a: "Перші дані — через 3-7 днів. Помітний результат — зазвичай за 3-4 тижні." },
    { q: "Чим це відрізняється від Google Smart Campaigns?", a: "Google Smart Campaigns оптимізують під кліки. Ми аналізуємо ваш LTV і конкретні ключові слова — і даємо рекомендації адаптовані під ваш бізнес." },
];

export const FAQ = () => {
    return (
        <section className="section" data-testid="faq-section">
            <div className="container-mx max-w-[820px]">
                <Reveal>
                    <h2 className="font-display font-extrabold text-text-primary text-center" style={{ fontSize: "clamp(32px, 4.5vw, 48px)", letterSpacing: "-0.02em" }}>
                        Питання, які виникають
                    </h2>
                </Reveal>

                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="mt-12 space-y-3">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="glass rounded-xl px-5 border-none data-[state=open]:border-primary/40"
                            >
                                <AccordionTrigger className="text-left font-display font-semibold text-base md:text-lg text-text-primary hover:no-underline py-5">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-secondary-c text-sm md:text-base pb-5 leading-relaxed">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
};

export default FAQ;
